import { getXmppLogin } from "src/modules/auth/duck/selectors";
import { generateOtp } from "src/modules/auth/ajax/cloud";
import { pairingTypes, pairingSources } from "src/modules/pairing/constants";

import * as actions from "../actions";
import * as cloud from "../../ajax/cloud";

const log = window.require("electron-log");

export default function initiatePairing({
  responder,
  pairingSource,
  flow,
  sendRequestMessage
}) {
  return async (dispatch, getState) => {
    try {
      dispatch(actions.pairingRequested({ responder, pairingSource }));
      flow.push("waiting");

      const xmppLogin = getXmppLogin(getState());
      const request = await cloud.requestDevicePairing(
        xmppLogin,
        responder.jid
      );

      dispatch(actions.receivedRequestData(request));

      switch (request.pairingType) {
        case pairingTypes.DEVICES:
          flow.push("devices-only");
          return;
        case pairingTypes.OUR_FAMILY:
        case pairingTypes.INITIAL: {
          const otpData = await generateOtp();
          sendRequestMessage({ otpData });
          return;
        }
        case pairingTypes.THEIR_FAMILY:
        case pairingTypes.THEIR_FAMILY_CREATE:
          sendRequestMessage();
          return;
        default:
          return;
      }
    } catch (error) {
      log.error(error);
      pairingSource === pairingSources.AUTO_PAIRING
        ? flow.push("nearby-devices", { direction: "previous" })
        : flow.push("scan-qr-code", { direction: "previous" });
      dispatch(actions.pairingFailed());
    }
  };
}
